<div class="flex flex-col">
  <div *ngIf="loading" class="flex justify-center my-3">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <div *ngFor="let notification of notifications; let i = index" class="mx-3 py-2">
    <div class="flex justify-between items-center cursor-pointer h-fit">
      <div class="flex items-center">
        <div *ngIf="!notification.is_read" class="dot"></div>
        <div class="flex flex-col" (click)="openNotification(notification)">
          <!-- Notificación tipo 5 y 6: renderizar HTML (use a plain div so HTML tags like <p><br> render naturally) -->
          <div *ngIf="notification.type === 5 || notification.type === 6"
            class="text-xs pl-3 text-ellipsis overflow-hidden line-clamp-2 hover:text-[#ffffffc0] break-words text-[#ffffffd0] whitespace-pre-wrap"
            [class]="!notification.is_read ? 'font-semibold' : ''" [innerHTML]="
              notification.safeHtml ||
              notification.originalData?.body ||
              notification.text
            "></div>
          <!-- Otras notificaciones: renderizar texto plano -->
          <ion-label *ngIf="notification.type !== 5 && notification.type !== 6"
            class="text-xs pl-3 text-ellipsis overflow-hidden line-clamp-2 hover:text-[#ffffffc0]"
            [class]="!notification.is_read ? 'font-semibold' : ''" color="light">{{ notification.text }}
          </ion-label>
          <ion-label class="!text-[11px] text-[#ffffffd0] ml-3">{{ notification.time }}- {{ notification.date }}
          </ion-label>
        </div>
      </div>

      <ion-button fill="clear" size="small" class="h-fit" (click)="deleteNotification(i)">
        <ion-icon class="text-[12px] text-[#ff3e3e]" src="../../../assets/svg/trash-bin.svg"
          slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </div>

  <div *ngIf="loadError && notifications.length === 0 && !loading" class="mx-3 py-4 text-center">
    <ion-label color="light">{{ 'NOTIFICATIONS.LOAD_ERROR' | translate }}</ion-label>
  </div>

  <!-- Mensaje cuando no hay notificaciones -->
  <div *ngIf="!loadError && notifications.length === 0 && !loading" class="mx-3 py-4 text-center">
    <ion-label color="light">{{ 'NOTIFICATIONS.EMPTY' | translate }}</ion-label>
  </div>

  <!-- Paginación simple -->
  <div *ngIf="totalPages > 1" class="flex justify-center my-2">
    <ion-button fill="clear" size="small" [disabled]="currentPage === 1" (click)="loadNotifications(currentPage - 1)">
      <ion-icon name="chevron-back" slot="icon-only"></ion-icon>
    </ion-button>
    <span class="text-white mx-2">{{ currentPage }} / {{ totalPages }}</span>
    <ion-button fill="clear" size="small" [disabled]="currentPage === totalPages"
      (click)="loadNotifications(currentPage + 1)">
      <ion-icon name="chevron-forward" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</div>

<app-notification-detail-dialog
  [show]="showNotificationDialog"
  [notification]="selectedNotification"
  [canOpenConversation]="canOpenSelectedConversation"
  [isProposal]="isSelectedProposal()"
  [actionKey]="getSelectedNotificationActionKey()"
  [selectedRoute]="selectedRoute"
  [sendingProposal]="sendingProposalResponse"
  (closed)="closeNotificationDialog()"
  (navigateChat)="navigateToChat($event, selectedNotification)"
  (startContact)="startContactFromNotification($event)"
  (accessRoute)="accessSelectedNotification($event)"
  (proposalSent)="handleProposalSent($event)">
</app-notification-detail-dialog>

<app-contact-finder-dialog
  [show]="showRecoveryOptionsDialog"
  [conversationId]="recoveryDialogConversationId"
  [premiumChatAmount]="recoveryDialogPremiumChatAmount"
  [ownerFreeMessage]="recoveryDialogOwnerFreeMessage"
  [ownerFreeMsgConsumed]="recoveryDialogOwnerFreeMsgConsumed"
  [finderFreeMessage]="recoveryDialogFinderFreeMessage"
  (premiumChatUnlocked)="onRecoveryDialogUnlocked()"
  (messageSent)="onRecoveryDialogMessageSent($event)"
  (publicProfileSettingsRequested)="onRecoveryDialogPublicProfileSettingsRequested()"
  (dialogDismissed)="onRecoveryDialogDismissed()">
</app-contact-finder-dialog>